<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isFetchingHolidays" :can-cancel="false"></b-loading>
    <h3 class="title is-3">Manage Holiday</h3>
    <hr />
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Name</label>
          <div class="control">
            <input type="text" v-model="holiday.name" class="input is-small" v-validate="'required'" name="Name" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Name') }}</span>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Month</label>
          <div class="control">
            <div class="select is-small">
              <select v-model="holiday.month">
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Day</label>
          <div class="control">
            <div class="select is-small">
              <select v-model="holiday.day">
                <option v-for="day in days" :key="day.day" :value="day">{{day}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Type of holiday</label>
          <div class="control">
            <div class="select is-small">
              <select v-model="holiday.typeOfHoliday">
                <option value="0">Regular holiday</option>
                <option value="1">Special non-working holiday</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button :class="buttonSave" @click="saveHoliday">{{createOrEdit}}</button>
    &nbsp;
    <button v-show="createOrEdit == 'Update'" class="button is-small" @click="cancelEdit">Cancel</button>
    &nbsp;
    <button class="button is-small" @click="getHolidays">Refresh table</button>
    <div style="clear:both"></div>
    <br />
    <b-table :data="holidays" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true">
      <template slot-scope="item">
        <b-table-column field="Name" class="table-column-content-is-small" label="Name">
          {{item.row.name}}
        </b-table-column>
        <b-table-column field="Date" class="table-column-content-is-small" label="Month & day">
          <strong>{{item.row.month}} {{item.row.day}}</strong>
        </b-table-column>
        <b-table-column field="TypeOfHoliday" class="table-column-content-is-small" label="Type of leave">
          {{item.row.typeOfHoliday}}
        </b-table-column>
        <b-table-column>
          <button class="button is-small is-warning" @click="editHoliday(item.row.holidayId)">Edit</button> &nbsp;
          <button class="button is-small is-danger" @click="deleteHoliday(item.row.holidayId)">Delete</button>
        </b-table-column>
      </template>
    </b-table>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete Holiday</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          Are you sure do you want to delete this permanently?
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="buttonDelete" @click="deletePermanently">Yes</button>
          <button class="button is-small" @click="cancel">No</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    createOrEdit: 'Create',
    showDeleteModal: false,
    holiday: {
      month: 1,
      day: 1,
      typeOfHoliday: 0
    },
    holidays: [],
    days: 31,
    isFetchingHolidays: false,
    buttonSave: appButton.isLoadingSuccess(false),
    buttonDelete: appButton.isLoadingDanger(false)
  }),
  created() {
    this.getHolidays()
  },
  methods: {
    saveHoliday() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          const holidayId = this.holiday.holidayId
          if (holidayId) {
            // Edit
            axios
              .put(`api/holidays/${holidayId}`, this.holiday)
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                console.log(error)
              })
              .then(() => {
                this.default()
              })
          } else {
            axios
              .post(`api/holidays`, this.holiday)
              .then(response => {
                appToast.success(response.data)
                this.default()
              })
              .catch(error => {
                appToast.danger(error.response.data)
              })
              .then(() => {
                this.buttonSave = appButton.isLoadingSuccess(false)
              })
          }
        }
      })
    },
    getHolidays() {
      this.isFetchingHolidays = true
      axios
        .get('api/holidays')
        .then(response => {
          this.holidays = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingHolidays = false
        })
    },
    editHoliday(id) {
      axios
        .get(`api/holidays/${id}`)
        .then(response => {
          this.holiday = response.data
          this.createOrEdit = 'Update'
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteHoliday(id) {
      this.showDeleteModal = true
      this.holiday.holidayId = id
    },
    deletePermanently() {
      if (this.showDeleteModal) {
        this.buttonDelete = appButton.isLoadingDanger(true)
        const holidayId = this.holiday.holidayId
        if (holidayId) {
          axios
            .delete(`api/holidays/${holidayId}`)
            .then(response => {
              appToast.success(response.data)
            })
            .catch(error => {
              console.log(error)
            })
            .then(() => {
              this.default()
            })
        }
      }
    },
    cancel() {
      this.showDeleteModal = false
    },
    default() {
      this.createOrEdit = 'Create'
      this.holiday = {
        month: 1,
        day: 1,
        typeOfHoliday: 0
      }
      this.showDeleteModal = false
      this.getHolidays()
      this.buttonSave = appButton.isLoadingSuccess(false)
      this.buttonDelete = appButton.isLoadingDanger(false)

      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    cancelEdit() {
      this.default()
    }
  }
}
</script>

